import React, { useState, useEffect } from "react";
import AdminLogin from "./AdminComps/AdminLogin";
import AdminMainPage from "./AdminComps/AdminMainPage";

export default function AdminPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if admin exists in localStorage
    const admin = localStorage.getItem("admin");
    if (admin) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return <div>{isLoggedIn ? <AdminMainPage /> : <AdminLogin />}</div>;
}
